export const SET_STORE_LOCATIONS = 'SET_STORE_LOCATIONS';
export const SET_STORE_LOCATIONS_BEFORE_FILTERS = 'SET_STORE_LOCATIONS_BEFORE_FILTERS';
export const SET_NUMBER_OF_FILTERS = 'SET_NUMBER_OF_FILTERS';
export const SET_IS_ALL_STORES_DATA_PRESENT = 'SET_IS_ALL_STORES_DATA_PRESENT';
export const SET_ALL_STORES = 'SET_ALL_STORES';
export const SET_ALL_STORE_LOCATIONS_BEFORE_FILTERS = 'SET_ALL_STORE_LOCATIONS_BEFORE_FILTERS';
export const SET_SPECIALTY_FILTER_DESCRIPTONS = 'SET_SPECIALTY_FILTER_DESCRIPTONS';

